import { FunctionComponent, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./DoctorInfo.css";
import editIcon from '../../assets/icons/edit.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Card from "../../atoms/CardV2/Card";
import { RiStethoscopeFill } from "react-icons/ri";
import Input from "../../atoms/Input/Input";

interface InfoProps {
  doctorDetails: any;
  onSave?: (updatedDetails: any, userType: string) => void;
}

const DoctorInfo: FunctionComponent<InfoProps> = ({ doctorDetails, onSave }) => {

  const [editedDetails, setEditedDetails] = useState<any>([]);

  useEffect(() => {
    if (doctorDetails) {
      setEditedDetails(doctorDetails)
    }
  }, [doctorDetails])

  return (
    <Card
    title="Doctor Info"
    titleIcon={<RiStethoscopeFill size={24} />}
    fullWidth={true}
    >
      <div className="doctor-info-content">
        <Input
          id="doc_name"
          label="Name"
          name="doc_name"
          value={editedDetails?.doc_name || ''}
          placeholder="---"
          type="text"
          readOnly
        />
        <Input
          id="doc_contac_no"
          label="Phone Number"
          name="doc_contac_no"
          value={editedDetails?.doc_contac_no || ''}
          placeholder="---"
          type="text"
          readOnly
        />
        <Input
          id="doc_city"
          label="City"
          name="doc_city"
          value={editedDetails?.doc_city || ''}
          placeholder="---"
          type="text"
          readOnly
        />
        <Input
          id="doc_clinic_name"
          label="Hospital"
          name="doc_clinic_name"
          value={editedDetails?.doc_clinic_name || ''}
          placeholder="---"
          type="text"
          readOnly
        />
      </div>
    </Card>
  );
};

export default DoctorInfo;
